export { default as ChevronDoubleRightIcon } from './ChevronDoubleRightIcon';
